import { SysTableState } from './interface';

export const getSysTableStatus = (state: SysTableState) => state.status;

export const getValgtSystemTable = (state: SysTableState) =>
  state.valgtSystemTable;
